import React from "react";
import Navbaartesting from "../components/Navbaartesting";
import Footer from "../components/Footer";
import { ImageData } from "../components/ImageData";

const ImgGallery = ({ images }) => {
  return (
    <>
      <Navbaartesting />
      <section className=" w-auto h-auto flex justify-start items-center flex-row block border-black flex-wrap pl-[7%] pr-[7%]">
        {ImageData.map((image) => (
          <div className="w-[150px] h-[150px]  border-2 mr-2 mb-2 bg-green-200">
            <img
              src={image.ImageUrl}
              alt={`Image ${image.id}`}
              key={image.id}
              style={{ width: "150px", height: "150px" }}
            />
          </div>
        ))}
      </section>
      <Footer />
    </>
  );
};

export default ImgGallery;
